export default __webpack_public_path__ + "static/media/mail.049c3c1a.svg";